/* nono 2026-10-10 basket v3: drawer + /cart behaviour.
   - One-tap adds ([data-nono-add]) with Add → Adding → Added, then re-render (drawer or /cart sections).
   - Add moment: "X added" toast, new line highlighted, bar animates old → new basis, sticker stamps on unlock.
   - Pinned upsell hides while the first in-scroll upsell card is fully visible (IntersectionObserver, threshold 1).
   - Quick-add size sheet ([data-nono-sheet]) and greeting-card sheet ([data-nono-cards]): bottom sheet, focus trap, Esc.
   - Gift note: cart.note via debounced /cart/update.js (200 chars).
   - Analytics: Shopify.analytics.publish custom events (nono_*). */
(() => {
  if (window.NonoV3) return;
  const NV = (window.NonoV3 = {});
  const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pub = (name, data) => {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, data || {}); } catch (e) {}
  };
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (c) => { const f = (window.nonoTheme && window.nonoTheme.moneyFormat) || '£{{amount}}'; const n = (c / 100).toFixed(2); return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k === 'amount_no_decimals' ? String(Math.round(c / 100)) : k === 'amount_with_comma_separator' ? n.replace('.', ',') : n.replace(/\B(?=(\d{3})+(?!\d))/g, ','))); }; // QA 2026-10-11 (S6): shop money format, not a £ literal
  const onCartPage = () => !!document.getElementById('main-cart-items');
  const drawerEl = () => document.querySelector('cart-drawer');
  const drawerOpen = () => { const d = drawerEl(); return d && d.classList.contains('active'); };
  const cartJSON = () => fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const PLUS = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const TICK = '<svg width="14" height="14" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M2 5.2l2 2 4-4.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const X = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3 3l14 14M17 3L3 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  // QA 2026-10-11 (S3): one live region outside the re-rendered drawer; status nodes inserted already-filled are often not announced.
  const liveEl = () => {
    let r = document.getElementById('NvLive');
    if (!r) { r = document.createElement('div'); r.id = 'NvLive'; r.className = 'visually-hidden'; r.setAttribute('role', 'status'); r.setAttribute('aria-live', 'polite'); document.body.appendChild(r); }
    return r;
  };
  const say = (msg) => { const r = liveEl(); r.textContent = ''; setTimeout(() => { r.textContent = msg; }, 60); };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- re-render ---------- */
  let pending = null; // {key, title, image} of the line just added
  function pageSections() {
    const items = document.getElementById('main-cart-items');
    const foot = document.getElementById('main-cart-footer');
    return [items && items.dataset.id, foot && foot.dataset.id, 'cart-icon-bubble'].filter(Boolean);
  }
  function applyPage(sections) {
    const items = document.getElementById('main-cart-items');
    const html = sections[items.dataset.id];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const src = doc.querySelector('.js-contents');
      if (src) items.querySelector('.js-contents').innerHTML = src.innerHTML;
    }
    const bub = document.getElementById('cart-icon-bubble');
    if (bub && sections['cart-icon-bubble']) {
      const d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (d) bub.innerHTML = d.innerHTML;
    }
    const ci = document.querySelector('cart-items.nv-cp');
    if (ci) ci.classList.toggle('is-empty', !document.querySelector('#main-cart-items .nv-li'));
    afterRender(document.querySelector('.nv-cp'));
    // keep the (hidden) drawer in step
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nono-v3' });
  }
  /* QA 2026-10-11 (M4): one painter for the drawer. Keeps focus inside the open drawer when the focused node is replaced,
     and never calls Dawn's open() on an already-open drawer (its once-only transitionend listener would later yank focus). */
  function paintDrawer(s) {
    const d = drawerEl();
    if (!d || !s || !s['cart-drawer']) return false;
    const doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
    const src = doc.querySelector('#CartDrawer');
    const tgt = document.getElementById('CartDrawer');
    if (!src || !tgt) return false;
    const hadFocus = d.contains(document.activeElement);
    tgt.innerHTML = src.innerHTML;
    d.classList.toggle('is-empty', !!doc.querySelector('.drawer__inner-empty'));
    const ov = d.querySelector('#CartDrawer-Overlay');
    if (ov) ov.addEventListener('click', d.close.bind(d));
    const bub = document.getElementById('cart-icon-bubble');
    if (bub && s['cart-icon-bubble']) {
      const b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bub.innerHTML = b.innerHTML;
    }
    afterRender(d);
    if (hadFocus && drawerOpen() && !d.contains(document.activeElement) && typeof trapFocus === 'function') {
      const inner = d.querySelector('.drawer__inner-empty') ? d.querySelector('.drawer__inner-empty') : tgt;
      trapFocus(inner, tgt.querySelector('.nv-li.is-new .nv-li__t') || tgt.querySelector('.drawer__inner'));
    }
    return true;
  }
  function refreshDrawer() {
    return fetch(root() + '?sections=cart-drawer,cart-icon-bubble')
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then((s) => { paintDrawer(s); })
      .catch(() => {
        const e = document.getElementById('CartDrawer-CartErrors');
        if (e) e.textContent = (window.cartStrings && window.cartStrings.error) || 'Sorry, your basket did not update. Please refresh the page.';
      });
  }
  function refreshPage() {
    const ids = pageSections();
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then((r) => r.json())
      .then((s) => applyPage(s))
      .catch(() => {});
  }
  NV.refreshDrawer = refreshDrawer;

  let addSeq = 0; // QA 2026-10-11 (M4): only the newest cart change may paint its section HTML
  // Dawn's stepper/remove (cart.js, source 'cart-items') also counts as newer: an add whose paint is still waiting must not undo it.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => { if (e && e.source === 'cart-items') addSeq++; });
  }
  function addItems(items, btn, meta) {
    const seq = ++addSeq;
    const page = onCartPage() && !drawerOpen();
    const sections = page ? pageSections() : ['cart-drawer', 'cart-icon-bubble'];
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Could not add');
        const it = (res.items && res.items[0]) || {};
        pending = { key: it.key, title: (meta && meta.title) || it.product_title, image: it.image, t: Date.now() };
        const done = () => {
          // A newer add started after this one: its response (or a fresh fetch) is the truth, never paint this older HTML.
          if (seq !== addSeq) return page ? refreshPage() : refreshDrawer();
          if (page) {
            applyPage(res.sections || {});
          } else if (drawerOpen()) {
            if (!paintDrawer(res.sections)) refreshDrawer();
          } else {
            const d = drawerEl();
            if (d && typeof d.renderContents === 'function') {
              d.classList.remove('is-empty');
              d.renderContents(res);
            } else refreshDrawer();
          }
        };
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          btn.innerHTML = TICK + 'Added';
          setTimeout(done, reduce() ? 300 : 1000);
        } else done();
        return res;
      });
  }
  NV.addItems = addItems;

  /* Patch Dawn: product-form add → also mark the add moment; cartUpdate from elsewhere → refresh the whole drawer (strip + footer). */
  let lastRender = 0, cuTimer = null; // QA 2026-10-11 (M5)
  customElements.whenDefined('cart-drawer').then(() => {
    const C = customElements.get('cart-drawer');
    if (!C || C.prototype.__nv) return;
    C.prototype.__nv = true;
    const orig = C.prototype.renderContents;
    C.prototype.renderContents = function (state) {
      lastRender = Date.now();
      if (!pending && state) {
        const it = state.items ? state.items[0] : state;
        if (it && it.key) pending = { key: it.key, title: null, image: it.image, t: Date.now() };
      }
      this.classList.remove('is-empty');
      orig.call(this, state);
      afterRender(this);
    };
  });
  customElements.whenDefined('cart-drawer-items').then(() => {
    const C = customElements.get('cart-drawer-items');
    if (!C || C.prototype.__nv) return;
    C.prototype.__nv = true;
    // product-form.js publishes cartUpdate and THEN calls renderContents with the same fresh sections; refreshing here as well
    // replaced #CartDrawer ~a fetch later, wiping the toast/highlight and the focused element. Defer, and skip if a render just happened.
    C.prototype.onCartUpdate = function () {
      clearTimeout(cuTimer);
      cuTimer = setTimeout(() => { if (Date.now() - lastRender > 1000) refreshDrawer(); }, 60);
    };
  });

  /* ---------- after every render ---------- */
  const last = {};
  function afterRender(scope) {
    scope = scope || document;
    // strips (drawer + page): animate fill from the last basis, stamp stickers on unlock
    scope.querySelectorAll('[data-nv-strip]').forEach((strip) => animateStrip(strip));
    // add moment
    if (pending && pending.key) {
      const row = scope.querySelector(`.nv-li[data-line-key="${CSS.escape(pending.key)}"]`);
      if (row) {
        row.classList.add('is-new');
        const name = pending.title || row.dataset.nvName || 'Item';
        const img = row.querySelector('.nv-li__im img');
        const list = row.closest('.nv-items');
        const t = document.createElement('div');
        t.className = 'nv-toast';
        t.setAttribute('aria-hidden', 'true');
        say(name + ' added to your basket');
        t.innerHTML = (img ? `<img src="${esc(img.getAttribute('src'))}" alt="" width="32" height="32">` : '') + `<span>${esc(name)} added</span><span class="nv-toast__ok">${TICK}</span>`;
        if (list) list.parentNode.insertBefore(t, list);
        setTimeout(() => t.classList.add('is-out'), 2500);
        setTimeout(() => t.remove(), 2900);
        setTimeout(() => row.classList.remove('is-new'), 4000);
        pending = null;
      } else if (!pending.t || Date.now() - pending.t > 8000) pending = null;
      // QA-20 2026-10-13: the MutationObserver re-runs afterRender(document) when the one-tap button swaps to "Adding/Added",
      // before the new line is painted; clearing pending there lost the toast, highlight and NvLive announcement.
    }
    bindPin(scope);
    bindViews(scope);
  }
  function animateStrip(strip) {
    const basis = parseInt(strip.dataset.basis, 10) || 0;
    const t1 = parseInt(strip.dataset.t1, 10) || 0;
    const t2 = parseInt(strip.dataset.t2, 10) || 0;
    const max = Math.max(t1, t2) || 1;
    const ctx = strip.classList.contains('nv-ms--page') ? 'page' : 'drawer';
    const prev = ctx in last ? last[ctx] : null;
    last[ctx] = basis;
    if (prev === null || prev === basis) return;
    const fill = strip.querySelector('.nv-trk__fill');
    const now = strip.querySelector('.nv-trk__now');
    const from = Math.min(100, (prev * 100) / max);
    const to = parseFloat(strip.dataset.pct) || 0;
    if (fill && !reduce()) {
      [fill, now].forEach((el) => { if (el) el.style.transition = 'none'; });
      fill.style.width = from + '%';
      if (now) now.style.left = from + '%';
      void fill.offsetWidth;
      requestAnimationFrame(() => {
        [fill, now].forEach((el) => { if (el) el.style.transition = ''; });
        fill.style.width = to + '%';
        if (now) now.style.left = to + '%';
      });
    }
    const crossed = [];
    if (t1 && prev < t1 && basis >= t1) crossed.push('delivery');
    if (t2 && prev < t2 && basis >= t2) crossed.push('print');
    crossed.forEach((k) => {
      const st = strip.querySelector(`[data-nv-st="${k}"]`);
      if (st && !reduce()) st.classList.add('is-stamp');
      pub('nono_milestone_unlock', { reward: k, preview: strip.classList.contains('nv-ms--preview') });
      say(k === 'delivery' ? 'Free UK delivery unlocked' : 'Free A6 print unlocked');
    });
    if (crossed.indexOf('delivery') > -1) {
      const sub = strip.querySelector('[data-nv-sub][data-nv-unlocked]');
      if (sub) {
        const keep = sub.textContent;
        sub.textContent = sub.dataset.nvUnlocked;
        sub.classList.add('is-hot');
        setTimeout(() => { sub.textContent = keep; sub.classList.remove('is-hot'); }, 4000);
      }
    }
  }

  /* ---------- pinned upsell ---------- */
  let pinIO = null;
  function bindPin(scope) {
    const wrap = document.querySelector('#CartDrawer [data-nv-pinwrap]');
    if (pinIO) { pinIO.disconnect(); pinIO = null; }
    if (!wrap) return;
    const card = document.querySelector('#CartDrawer .nv-ups .nv-uc');
    const scroller = document.querySelector('#CartDrawer [data-nv-scroll]');
    if (!card || !scroller || !('IntersectionObserver' in window)) return;
    pinIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => { wrap.hidden = e.intersectionRatio >= 0.99; });
    }, { root: scroller, threshold: [0, 0.99, 1] });
    pinIO.observe(card);
  }

  /* ---------- upsell view analytics (once per position per page view) ---------- */
  const seen = {};
  const viewIOs = []; // QA 2026-10-11 (S4): every re-render used to add observers on nodes that were then replaced, never disconnected
  function bindViews() {
    if (!('IntersectionObserver' in window)) return;
    while (viewIOs.length) viewIOs.pop().disconnect();
    document.querySelectorAll('[data-nv-row], [data-nv-pin]').forEach((el) => {
      const pos = el.matches('[data-nv-pin]') ? 'pinned' : 'inline';
      if (seen[pos]) return;
      const io = new IntersectionObserver((en) => {
        if (en.some((x) => x.isIntersecting) && !seen[pos]) { seen[pos] = 1; pub('nono_upsell_view', { position: pos }); io.disconnect(); }
      });
      io.observe(el);
      viewIOs.push(io);
    });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', (ev) => {
    const add = ev.target.closest('[data-nono-add]');
    if (add) {
      ev.preventDefault();
      if (add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      add.classList.add('is-busy');
      const label = add.innerHTML;
      add.innerHTML = '<span class="nv-spin" aria-hidden="true"></span>Adding';
      const item = { id: parseInt(add.dataset.nonoAdd, 10), quantity: 1 };
      if (add.dataset.nonoFree) item.properties = { _nono_free_print: '1' };
      const ev2 = add.dataset.nvEv || 'inline';
      const meta = { title: add.dataset.nvTitle };
      addItems([item], add, meta)
        .then(() => {
          if (ev2 === 'free_print') pub('nono_free_print_choose', { variant: item.id });
          else if (ev2 === 'empty') pub('nono_empty_bestseller_add', { variant: item.id });
          else if (ev2 === 'card') pub('nono_gift_card_add', { variant: item.id });
          else {
            pub('nono_upsell_add', { position: ev2, variant: item.id, size: add.dataset.nvSize || '', gap_closer: !!add.dataset.nvGap });
            if (add.dataset.nvGap) pub('nono_gap_closer_add', { variant: item.id });
          }
        })
        .catch((e) => {
          add.removeAttribute('aria-busy');
          add.classList.remove('is-busy');
          add.innerHTML = label;
          const msg = document.createElement('p');
          msg.className = 'nv-err';
          msg.setAttribute('role', 'alert');
          msg.textContent = (e && e.message) || 'Sorry, that could not be added.';
          add.parentNode.appendChild(msg);
          setTimeout(() => msg.remove(), 4000);
        });
      return;
    }
    const choose = ev.target.closest('[data-nv-choose]');
    if (choose) {
      const id = (choose.getAttribute('href') || '').slice(1);
      const tgt = id && document.getElementById(id);
      if (tgt) {
        ev.preventDefault();
        const sc = tgt.closest('[data-nv-scroll]');
        if (sc) {
          const y = tgt.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 8;
          sc.scrollTo({ top: y, behavior: reduce() ? 'auto' : 'smooth' });
        } else {
          window.scrollTo({ top: tgt.getBoundingClientRect().top + window.scrollY - 80, behavior: reduce() ? 'auto' : 'smooth' });
        }
        const b = tgt.querySelector('[data-nono-add]');
        if (b) setTimeout(() => b.focus({ preventScroll: true }), reduce() ? 0 : 450);
      }
      return;
    }
    const sh = ev.target.closest('[data-nono-sheet]');
    if (sh) { ev.preventDefault(); openSizeSheet(sh.dataset.nonoSheet, sh); return; }
    const cs = ev.target.closest('[data-nono-cards]');
    if (cs) { ev.preventDefault(); openCardSheet(cs.dataset.nonoCards, cs); return; }
    const nt = ev.target.closest('[data-nv-note-toggle]');
    if (nt) {
      const box = document.getElementById(nt.getAttribute('aria-controls'));
      if (box) {
        box.hidden = false;
        nt.setAttribute('aria-expanded', 'true');
        nt.hidden = true;
        const ta = box.querySelector('textarea');
        if (ta) ta.focus();
      }
    }
  });

  /* ---------- gift note ---------- */
  let noteTimer = null, noteTa = null;
  function saveNote(ta) {
    clearTimeout(noteTimer); noteTimer = null; noteTa = null;
    const v = ta.value.slice(0, 200);
    return fetch(root() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: v }),
    }).then((r) => {
      if (!r.ok) throw new Error(r.status); // QA 2026-10-11 (S5): don't show "Saved" for a 4xx/5xx
      const s = ta.parentNode.querySelector('[data-nv-note-saved]');
      if (s) { s.hidden = false; setTimeout(() => (s.hidden = true), 1500); }
      document.querySelectorAll('[data-nv-note]').forEach((o) => { if (o !== ta) o.value = v; });
      if (v) pub('nono_gift_note_saved', { length: v.length });
    }).catch(() => {
      const s = ta.parentNode.querySelector('[data-nv-note-saved]');
      if (s) { s.hidden = false; s.textContent = ' · Not saved, please try again'; }
    });
  }
  // QA 2026-10-11 (S5): a note typed <700 ms before "Checkout securely" was lost. Flush the pending save, then submit.
  document.addEventListener('submit', (e) => {
    if (!noteTimer || !noteTa) return;
    e.preventDefault();
    const f = e.target, sub = e.submitter;
    saveNote(noteTa).finally(() => { if (f.requestSubmit) f.requestSubmit(sub || undefined); else f.submit(); });
  }, true);
  ['input', 'change'].forEach((type) =>
    document.addEventListener(type, (ev) => {
      const ta = ev.target.closest && ev.target.closest('[data-nv-note]');
      if (!ta) return;
      ev.stopPropagation(); // keep Dawn's cart-items from treating it as a quantity change
      const ct = ta.parentNode.querySelector('[data-nv-note-count]');
      if (ct) ct.textContent = ta.value.length;
      clearTimeout(noteTimer);
      noteTa = ta;
      noteTimer = setTimeout(() => saveNote(ta), type === 'change' ? 0 : 700);
    }, true)
  );

  /* QA-03 2026-10-13: typed quantity. Enter commits in place (never submits the form to checkout); Tab commits even when
     something else (e.g. the cookie banner's focus handling) swallows the blur, so the basket always matches what was typed. */
  document.addEventListener('keydown', (ev) => {
    const i = ev.target && ev.target.closest && ev.target.closest('.nv-q__in, cart-items input.quantity__input, cart-drawer-items input.quantity__input');
    if (!i || (ev.key !== 'Enter' && ev.key !== 'Tab')) return;
    if (ev.key === 'Enter') ev.preventDefault();
    if (i.value !== '' && i.value !== i.getAttribute('value')) i.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  /* ---------- bottom sheet ---------- */
  let sheet = null, sheetReturn = null;
  // QA 2026-10-11 (S2): Dawn's cart-drawer closes on *keyup* Escape. The sheet closes on keydown and returns focus into the
  // drawer, so the same key's keyup reached cart-drawer and closed it too. Swallow that one keyup (capture phase).
  let escGuard = false;
  document.addEventListener('keyup', (e) => { if (escGuard && e.key === 'Escape') { e.stopPropagation(); escGuard = false; } }, true);
  function closeSheet() {
    if (!sheet) return;
    sheet.remove();
    sheet = null;
    document.removeEventListener('keydown', sheetKeys, true);
    const d = drawerEl();
    if (d && d.classList.contains('active') && typeof trapFocus === 'function') {
      trapFocus(document.getElementById('CartDrawer'), sheetReturn && document.contains(sheetReturn) ? sheetReturn : null);
    } else if (sheetReturn && document.contains(sheetReturn)) sheetReturn.focus();
  }
  function sheetKeys(e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); escGuard = true; closeSheet(); return; }
    if (e.key !== 'Tab') return;
    const f = [...sheet.querySelectorAll('button:not([disabled]), a[href]')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    else if (!sheet.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }
  function openSheet(title, sub, img, rowsHTML, trigger) {
    closeSheet();
    sheetReturn = trigger;
    if (typeof removeTrapFocus === 'function') try { removeTrapFocus(); } catch (e) {}
    sheet = document.createElement('div');
    sheet.className = 'nv nv-sheetwrap';
    sheet.innerHTML = `<div class="nv-dim" data-nv-sheet-close></div>
      <div class="nv-sheet" role="dialog" aria-modal="true" aria-labelledby="NvSheetH" tabindex="-1">
        <div class="nv-sheet__grab" aria-hidden="true"></div>
        <div class="nv-sheet__hd">${img ? `<img src="${esc(img)}" alt="" width="56" height="56">` : ''}
          <div><b id="NvSheetH">${esc(title)}</b><span>${esc(sub)}</span></div>
          <button type="button" class="nv-x" data-nv-sheet-close aria-label="Close">${X}</button></div>
        <div class="nv-sheet__rows">${rowsHTML}</div>
      </div>`;
    document.body.appendChild(sheet);
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-nv-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', sheetKeys, true);
    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
      const b = sheet.querySelector('.nv-sheet__rows button') || sheet.querySelector('.nv-sheet');
      b.focus();
    });
    // adds inside the sheet
    sheet.querySelectorAll('[data-nv-sheet-add]').forEach((b) =>
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (b.getAttribute('aria-busy') === 'true') return;
        b.setAttribute('aria-busy', 'true');
        b.classList.add('is-busy');
        b.innerHTML = '<span class="nv-spin" aria-hidden="true"></span>Adding';
        const id = parseInt(b.dataset.nvSheetAdd, 10);
        addItems([{ id, quantity: 1 }], null, { title: b.dataset.nvTitle })
          .then(() => {
            pub(b.dataset.nvEv === 'card' ? 'nono_gift_card_add' : (trigger && trigger.dataset.nvEv === 'empty' ? 'nono_empty_bestseller_add' : 'nono_upsell_add'), { variant: id, size: b.dataset.nvSize || '', position: 'sheet' });
            sheetReturn = null;
            closeSheet();
          })
          .catch((err) => {
            b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); b.innerHTML = PLUS + 'Add';
            // QA 2026-10-11 (S12): was silent; show the 422 description ("only N left") or a generic message
            const m = document.createElement('p'); m.className = 'nv-err'; m.setAttribute('role', 'alert');
            m.textContent = (err && err.message) || 'Sorry, that could not be added.';
            b.closest('.nv-sz').appendChild(m); setTimeout(() => m.remove(), 5000);
          });
      })
    );
  }
  // 2026-10-13 live fix: real compare-at only (no theme-side % maths). Accepts cents or a '12.99' string.
  const toCents = (x) => (x == null || x === '' ? 0 : typeof x === 'number' ? x : Math.round(parseFloat(x) * 100));
  const shortTitle = (t) => {
    let s = String(t || '');
    const cut = s.split(/\s[-–|]\s/)[0];
    return cut.length > 4 ? cut : s;
  };
  function sizeLabel(v) {
    const o = String(v.option1 || v.title || '');
    const m = o.match(/^(A\d)\s*-\s*(.+)$/);
    let main, dim = '';
    // QA-07 2026-10-13: dims from the size guide (ISO 216), never from the variant title ("10cm x 15cm" is wrong)
    const ISO = { A6: '10.5 × 14.8 cm', A5: '14.8 × 21 cm', A4: '21 × 29.7 cm', A3: '29.7 × 42 cm', A2: '42 × 59.4 cm', A1: '59.4 × 84.1 cm', A0: '84.1 × 118.9 cm' };
    if (m) { main = m[1]; dim = ISO[m[1]] || m[2].replace(/cm/g, '').replace(/\s*x\s*/g, ' × ').trim() + ' cm'; }
    else main = o;
    const extra = [v.option2, v.option3].filter(Boolean).join(' · ');
    return { main, dim: [dim, extra].filter(Boolean).join(' · '), short: m ? m[1] : o };
  }
  function openSizeSheet(handle, trigger) {
    fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((p) => {
        let vs = (p.variants || []).filter((v) => v.available);
        // spec: A6/A5/A4/A3 rows; bigger sizes stay on the product page ("More sizes")
        const core = vs.filter((v) => /^A[3-6]\b/.test(v.option1 || ''));
        const more = core.length && core.length < vs.length;
        if (core.length) vs = core;
        const name = trigger.dataset.nvTitle || shortTitle(p.title);
        if (vs.length === 1) { addItems([{ id: vs[0].id, quantity: 1 }], trigger.classList.contains('nv-ab') ? trigger : null, { title: name }); return; }
        const rows = vs.map((v) => {
          const s = sizeLabel(v);
          const sp = v.price;
          const ca = toCents(v.compare_at_price);
          const was = ca > sp ? `<s><span class="visually-hidden">Was </span>${money(ca)}</s>` : '';
          return `<div class="nv-sz"><span class="nv-sz__l">${esc(s.main)}<span class="nv-sz__d">${esc(s.dim)}</span></span>
            <span class="nv-sz__r">${was}<b><span class="visually-hidden">Now </span>${money(sp)}</b>
            <button type="button" class="nv-ab nv-ab--sm" data-nv-sheet-add="${v.id}" data-nv-title="${esc(name)}" data-nv-size="${esc(s.short)}">${PLUS}Add<span class="visually-hidden"> ${esc(s.main)}</span></button></span></div>`;
        }).join('');
        const isPrint = vs.some((v) => /^A\d/.test(v.option1 || ''));
        const moreLink = more ? `<a class="nv-sheet__more" href="${esc(root() + 'products/' + p.handle)}">More sizes (A2–A0)<svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M4 2l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></a>` : '';
        openSheet(name, isPrint ? 'Choose a size · print only, frame not included' : 'Choose an option', p.featured_image, rows + moreLink, trigger);
      })
      .catch(() => { window.location.href = root() + 'products/' + handle; });
  }
  function openCardSheet(handle, trigger) {
    Promise.all([
      fetch(root() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=24').then((r) => r.json()),
      cartJSON(),
    ])
      .then(([data, cart]) => {
        const inCart = new Set((cart.items || []).map((i) => i.product_id));
        const ps = (data.products || []).filter((p) => !inCart.has(p.id) && p.variants.some((v) => v.available) && !/multipack/i.test(p.title + ' ' + p.handle) && !(p.tags || []).includes('Charity_Cards')); // P2 QA-08 2026-10-13: card packs stay out of the picker
        if (!ps.length) { window.location.href = root() + 'collections/' + handle; return; }
        const rows = ps.map((p) => {
          const v = p.variants.filter((x) => x.available).sort((a, b) => parseFloat(a.price) - parseFloat(b.price))[0];
          const cents = Math.round(parseFloat(v.price) * 100);
          const sp = cents;
          const ca = toCents(v.compare_at_price);
          const img = p.images && p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_120x120$1$2') : '';
          const nm = shortTitle(p.title);
          return `<div class="nv-sz nv-sz--card">${img ? `<img src="${esc(img)}" alt="" width="48" height="48">` : ''}<span class="nv-sz__l nv-sz__l--card">${esc(nm)}${p.variants.length > 1 ? `<span class="nv-sz__d">${esc(v.title)}</span>` : ''}</span>
            <span class="nv-sz__r">${ca > sp ? `<s><span class="visually-hidden">Was </span>${money(ca)}</s>` : ''}<b><span class="visually-hidden">Now </span>${money(sp)}</b>
            <button type="button" class="nv-ab nv-ab--sm" data-nv-sheet-add="${v.id}" data-nv-ev="card" data-nv-title="${esc(nm)}">${PLUS}Add<span class="visually-hidden"> ${esc(nm)}</span></button></span></div>`;
        }).join('');
        openSheet('Add a greeting card', 'Pick a design · A6 card with envelope', null, rows, trigger);
      })
      .catch(() => { window.location.href = root() + 'collections/' + handle; });
  }
  NV.openSizeSheet = openSizeSheet;

  /* ---------- boot ---------- */
  let moTimer = null;
  const boot = () => {
    liveEl();
    afterRender(document);
    if (!('MutationObserver' in window)) return;
    const mo = new MutationObserver(() => {
      clearTimeout(moTimer);
      moTimer = setTimeout(() => afterRender(document), 30);
    });
    ['CartDrawer', 'main-cart-items'].forEach((id) => { const el = document.getElementById(id); if (el) mo.observe(el, { childList: true, subtree: true }); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
